<style scoped>
    .shape{
        display: inline-block;
        vertical-align: top;
        width: 220px;
        padding: 2px;
        margin: 2px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        font-weight: bold;
        cursor: pointer;
    }
    .shape-name{
        border-bottom: 1px solid #dddee1;
        padding: 3px 0;
        margin-bottom: 3px;
    }
    .shape-btn{
        display: inline-block;
        vertical-align: middle;
        height: 20px;
        width: 20px;
        line-height: 16px;
        text-align: center;
        border: 1px solid #dddee1;
        border-radius: 10px;
        cursor: pointer;
    }
    .shape-btn:hover{
        background: #dddee1;
    }
    input{
        width: 100%;
        padding: 0 2px;
        border: 1px solid #dddee1;
        border-radius: 4px;
    }
    .ivu-cell{
        padding: 2px 4px;
    }
    .points-group /deep/ .ivu-input-number-handler-wrap{
        display: none;
    }
</style>
<template>
  <div
    class="shape"
    @click.stop="click"
    @keydown.stop=""
  >
    <div class="shape-name text-center">
      <span>{{ item.shape }}</span>
      <Poptip
        popper-class="poptip-no-padding"
        width="200"
        placement="left"
      >
        <Button
          size="small"
          shape="circle"
          icon="ios-settings"
        />
        <CellGroup slot="content">
          <Cell>
            <span>粗糙</span>
            <span slot="extra">
              <InputNumber
                v-model="item_options.roughness"
                size="small"
                :min="0"
                :max="10"
                :step="0.1"
                @on-change="dataChange"
              />
            </span>
          </Cell>
          <Cell>
            <span>弯曲</span>
            <span slot="extra">
              <InputNumber
                v-model="item_options.bowing"
                size="small"
                :min="0"
                :step="0.1"
                @on-change="dataChange"
              />
            </span>
          </Cell>
          <Cell>
            <span>线颜色</span>
            <span slot="extra">
              <i-colorPicker
                v-model="item_options.stroke"
                recommend
                size="small"
                @on-change="dataChange"
              ></ColorPicker>
              </i-colorpicker></span>
          </Cell>
          <Cell>
            <span>线宽</span>
            <span slot="extra">
              <InputNumber
                v-model="item_options.strokeWidth"
                size="small"
                :min="1"
                :step="1"
                @on-change="dataChange"
              />
            </span>
          </Cell>
          <Cell>
            <span>填充样式</span>
            <span slot="extra">
              <Select
                v-model="item_options.fillStyle"
                size="small"
                placeholder="填充样式"
                @on-change="dataChange"
              >
                <Option value="hachure">hachure</Option>
                <Option value="solid">solid</Option>
                <Option value="zigzag">zigzag</Option>
                <Option value="cross-hatch">cross-hatch</Option>
                <Option value="dots">dots</Option>
                <Option value="sunburst">sunburst</Option>
                <Option value="dashed">dashed</Option>
                <Option value="zigzag-line">zigzag-line</Option>
              </Select>
            </span>
          </Cell>
          <Cell>
            <span>填充颜色</span>
            <span slot="extra">
              <i-colorPicker
                v-model="item_options.fill"
                recommend
                size="small"
                @on-change="dataChange"
              ></ColorPicker>
              </i-colorpicker></span>
          </Cell>
          <Cell>
            <span>填充线宽</span>
            <span slot="extra">
              <InputNumber
                v-model="item_options.fillWeight"
                size="small"
                :min="0.5"
                :step="0.5"
                @on-change="dataChange"
              />
            </span>
          </Cell>
          <Cell>
            <span>填充角度</span>
            <span slot="extra">
              <InputNumber
                v-model="item_options.hachureAngle"
                size="small"
                :min="-90"
                :max="90"
                :step="1"
                @on-change="dataChange"
              />
            </span>
          </Cell>
          <Cell>
            <span>填充间隔</span>
            <span slot="extra">
              <InputNumber
                v-model="item_options.hachureGap"
                size="small"
                :min="0"
                :max="20"
                :step="1"
                @on-change="dataChange"
              />
            </span>
          </Cell>
          <!--<Cell>
                        <span>curveStepCount</span>
                        <span slot="extra">
                            <InputNumber size="small" :min="0" :max="20" :step="1" @on-change="dataChange" v-model="item_options.curveStepCount"></InputNumber>
                        </span>
                    </Cell>-->
        </CellGroup>
      </Poptip>
      <Poptip
        confirm
        title="你确定要复制吗？"
        @on-ok="copy"
      >
        <Button
          size="small"
          shape="circle"
          icon="ios-copy"
        />
      </Poptip>
      <Poptip
        confirm
        transfer
        title="您确认删除吗?"
        @on-ok="del"
      >
        <Button
          size="small"
          shape="circle"
          icon="md-close"
        />
      </Poptip>
    </div>
    <CellGroup v-if="item.shape === 'line'">
      <Cell>
        <span>x1</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.x1"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>y1</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.y1"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>x2</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.x2"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>y2</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.y2"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
    </CellGroup>
    <CellGroup v-if="item.shape === 'rectangle' || item.shape === 'ellipse' || item.shape === 'arc'">
      <Cell>
        <span>x</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.x"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>y</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.y"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>w</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.w"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>h</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.h"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <div v-if="item.shape === 'arc'">
        <Cell>
          <span>start</span>
          <span slot="extra">
            <InputNumber
              v-model="item.data.start"
              size="small"
              @on-change="dataChange"
            />
          </span>
        </Cell>
        <Cell>
          <span>stop</span>
          <span slot="extra">
            <InputNumber
              v-model="item.data.stop"
              size="small"
              @on-change="dataChange"
            />
          </span>
        </Cell>
        <Cell>
          <span>closed</span>
          <span slot="extra">
            <input
              v-model="item.data.closed"
              type="checkbox"
              @on-change="dataChange"
            ></InputNumber>
          </span>
        </Cell>
      </div>
    </CellGroup>
    <CellGroup v-if="item.shape === 'circle'">
      <Cell>
        <span>x</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.x"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>y</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.y"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
      <Cell>
        <span>d</span>
        <span slot="extra">
          <InputNumber
            v-model="item.data.d"
            size="small"
            @on-change="dataChange"
          />
        </span>
      </Cell>
    </CellGroup>
    <CellGroup
      v-if="item.shape === 'linearPath' || item.shape === 'polygon' || item.shape === 'curve'"
      class="points-group"
    >
      <Cell
        v-for="(point, index) in item.data.points"
        :key="index"
      >
        <InputNumber
          v-model="point.x"
          size="small"
          placeholder="x"
          style="width: 40px"
          @on-change="dataChange"
        />
        <InputNumber
          v-model="point.y"
          size="small"
          placeholder="y"
          style="width: 40px"
          @on-change="dataChange"
        />
        <div
          v-if="index === item.data.points.length - 1"
          class="shape-btn"
          @click="addPoint(index)"
        >
          <Icon type="md-add" />
        </div>
        <div
          class="shape-btn"
          @click="delPoint(index)"
        >
          <Icon type="md-close" />
        </div>
      </Cell>
    </CellGroup>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    props: ['item', 'index'],
    data() {
      return {
        //
      }
    },
    computed: {
      item_data() {
        return this.item.data;
      },
      item_options() {
        return this.item_data ? this.item_data.options : {};
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      dataChange() {
        this.$emit('change');
      },
      click(ev) {
        const is_add = ev.altKey || ev.shiftKey || ev.ctrlKey;
        this.$emit('click', this.item, is_add);
      },
      copy() {
        this.$emit('copy', this.item, this.index);
        this.$emit('change');
      },
      del() {
        this.$emit('del', this.item);
        this.$emit('change');
      },
      addPoint(index) {
        this.item.data.points.push({x: 200, y: 200});
        this.$emit('change');
      },
      delPoint(index) {
        this.item.data.points.splice(index, 1);
        this.$emit('change');
      },
    }
  }
</script>
